export const SignatureTypes = {
  institution: {
    name: '<INST> CNPJ ADRB COMPOSITE ENVELOPED',
    signPacking: 'enveloped',
    signPolicy: 'AD_RB',
    policyVersion: '2.4',
    hashAlgorithm: 'sha-256',
    level: 1,
    signType: 'COMPOSITE_SIGNATURE',
  },
  archive: {
    name: '<INST> CNPJ ADRA COMPOSITE ENVELOPED',
    signPacking: 'enveloped',
    signPolicy: 'AD_RA',
    policyVersion: '2.4',
    hashAlgorithm: 'sha-256',
    level: 1,
    signType: 'COMPOSITE_SIGNATURE',
  },
  person: {
    name: '<NÓ ASSINADO> <INST> ADRB PARALLEL ENVELOPED',
    signPacking: 'enveloped',
    signPolicy: 'AD_RB',
    policyVersion: '2.4',
    hashAlgorithm: 'sha-256',
    level: 1,
    signType: 'PARALLEL_SIGNATURE',
  },
};

export const TagTypes = {
  Diploma: {
    tagID: 'TAG Diploma RAIZ <INST>',
    tagName: 'Diploma',
  },
  DadosDiploma: {
    tagID: 'TAG Doc Acad DadosDiploma <INST>',
    tagName: 'DadosDiploma',
  },
  DadosRegistro: {
    tagID: 'TAG Diploma DadosRegistro <INST>',
    tagName: 'DadosRegistro',
  },
  DocumentacaoAcademicaRegistro: {
    tagID: 'TAG Doc Acad RAIZ <INST>',
    tagName: 'DocumentacaoAcademicaRegistro',
  },
};

export const Permissions = {
  NORMAL_USER: 1,
  REPORTER: 256,
  MANAGER: 512,
  MAINTAINER: 1024,
  ADMIN: 2048,
};

export const timestampTypes = [
  {
    label: 'Carimbo de Assinatura',
    value: 1,
  },
  {
    label: 'Carimbo de Referências',
    value: 2,
  },
  {
    label: 'Carimbo de Arquivamento',
    value: 3,
  },
];

export const documentTypes = [
  {
    label: 'Documentação Acadêmica',
    value: 1,
  },
  {
    label: 'Diploma Digital',
    value: 2,
  },
  {
    label: 'Representação Visual do Diploma',
    value: 5,
  },
  {
    label: 'Histórico Escolar Final',
    value: 9,
  },
  {
    label: 'Representação Visual do Histórico',
    value: 15,
  },
  {
    label: 'Lista de Diplomas Anulados',
    value: 10,
  },
  {
    label: 'Arquivo de Fiscalização da Registradora',
    value: 11,
  },
  {
    label: 'Arquivo de Fiscalização da Emissora',
    value: 12,
  },
  {
    label: 'Currículo Escolar Digital',
    value: 13,
  },
  {
    label: 'Representação Visual do Currículo',
    value: 14,
  },
  {
    label: 'Documentação Acadêmica Externa',
    value: 8,
  },
  {
    label: 'Diploma Externo',
    value: 7,
  },
  {
    label: 'Histórico Escolar Parcial',
    value: 16,
  },
  {
    label: 'Desconhecido',
    value: 17,
  },
];

export const batchRegistriesStatus = [
  {
    label: 'Aberto',
    value: 1,
  },
  {
    label: 'Fechado',
    value: 2,
  },
  {
    label: 'Registrado',
    value: 3,
  },
  {
    label: 'Com falha',
    value: 4,
  },
];

export const providers = [
  {
    label: 'Ledger',
    value: 1,
  },
  {
    label: 'Bry',
    value: 2,
  },
];

export const dateFilterCriteriaList = [
  {
    label: 'Data de criação',
    value: 'CREATE',
  },
  {
    label: 'Data de última modificação',
    value: 'UPDATE',
  },
];

export const SignConfigName = 'Configuração Assinatura <Tipo Doc> <INST>';

export const DocConfigName = 'Configuração <Tipo Doc> <INST>';

export const documentRepairTypes = [
  {
    label: 'Histórico Escolar Parcial',
    value: 1,
  },
  {
    label: 'Diploma Digital',
    value: 2,
  },
  {
    label: 'Histórico Escolar Final',
    value: 3,
  },
  {
    label: 'Documentação Acadêmica',
    value: 4,
  },
  {
    label: 'Representação Visual do Diploma',
    value: 5,
  },
  {
    label: 'Diploma Externo',
    value: 6,
  },
  {
    label: 'Documentação Acadêmica Externa',
    value: 7,
  },
  {
    label: 'Lista de Diplomas Anulados',
    value: 8,
  },
  {
    label: 'Arquivo de Fiscalização da Registradora',
    value: 9,
  },
  {
    label: 'Arquivo de Fiscalização da Emissora',
    value: 10,
  },
  {
    label: 'Currículo Escolar Digital',
    value: 11,
  },
  {
    label: 'Representação Visual do Currículo',
    value: 12,
  },
  {
    label: 'Representação Visual do Histórico',
    value: 13,
  },
];

export const repairResultStatus = {
  success: 'Sucesso',
  error: 'Erro',
};

export const documentFixGroups = [
  {
    label: 'Atualização de Dados e Regeneração',
    value: 'doc_update_regen',
  },
  {
    label: 'Apenas Regeneração de Documento',
    value: 'doc_regen',
  },
  {
    label: 'Remoção da Assinatura de Arquivamento',
    value: 'sign_removal',
  },
];

export const origins = [
  {
    label: 'Registro',
    value: 'registration',
  },
  {
    label: 'Renotarização',
    value: 'renotarization',
  },
  {
    label: 'Atualização',
    value: 'update',
  },
];
